/* lhx-teclado.js — UnionX 14/08/2026
   El tema pone html y body en overflow:hidden y quien scrollea es div.page-wrapper, que no
   es enfocable. Al cargar la pagina las teclas van al documento, ahi no hay nada que
   desplazar, y PageDown/End/Espacio no hacen NADA hasta que el usuario hace un clic.
   Medido en home, coleccion y ficha: sin tocar 0 -> 0; tras un clic 0 -> 787.

   No se le pone foco automatico al wrapper: eso dejaria al "Saltar al contenido" fuera del
   primer Tab. Se atiende la tecla solo cuando NO hay nada enfocado (activeElement es el body),
   que es justo el caso roto, y se deja pasar todo lo demas. */
(function () {
  'use strict';
  var TECLAS = { PageDown: 1, PageUp: 1, End: 1, Home: 1, ' ': 1, ArrowDown: 1, ArrowUp: 1 };

  function wrapper() {
    var w = document.querySelector('div.page-wrapper');
    return (w && w.scrollHeight > w.clientHeight + 20) ? w : null;
  }

  document.addEventListener('keydown', function (e) {
    if (!TECLAS[e.key] || e.ctrlKey || e.metaKey || e.altKey) return;
    var a = document.activeElement;
    // si hay algo enfocado (un campo, un boton, un enlace) no nos metemos
    if (a && a !== document.body && a !== document.documentElement) return;
    // 🪤 la ficha trae un [aria-modal="true"] CERRADO (la guia de tallas). Preguntar si
    // existe deja el teclado muerto en toda la ficha: hay que preguntar si se VE.
    var modales = document.querySelectorAll('dialog[open], [aria-modal="true"]');
    for (var i = 0; i < modales.length; i++) {
      var r = modales[i].getBoundingClientRect();
      if (r.width > 1 && r.height > 1) return;   // hay un modal a la vista: la tecla es suya
    }
    var w = wrapper(); if (!w) return;
    var alto = w.clientHeight;
    switch (e.key) {
      case 'PageDown': w.scrollBy({ top: alto * 0.9, behavior: 'smooth' }); break;
      case ' ':        w.scrollBy({ top: (e.shiftKey ? -1 : 1) * alto * 0.9, behavior: 'smooth' }); break;
      case 'PageUp':   w.scrollBy({ top: -alto * 0.9, behavior: 'smooth' }); break;
      case 'End':      w.scrollTo({ top: w.scrollHeight, behavior: 'smooth' }); break;
      case 'Home':     w.scrollTo({ top: 0, behavior: 'smooth' }); break;
      case 'ArrowDown': w.scrollBy({ top: 60 }); break;
      case 'ArrowUp':   w.scrollBy({ top: -60 }); break;
    }
    e.preventDefault();
  }, { passive: false });
})();
